export default "__VITE_ASSET__Z66PEL_$__"